<template>
  <div>Something went wrong, try to refresh the page...</div>
</template>

<script>
export default {}
</script>

